import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'topo-header-bar-tab-button',
    templateUrl: './header-bar-tab-button.component.html',
    styleUrls: ['./header-bar-tab-button.component.scss'],
    standalone: false
})
export class HeaderBarTabButtonComponent implements OnInit {
  @Input() theme: string;
  @Input() label: string;
  @Input() icon: string;

  @Input() set isSelected(value: boolean) {
    this.isSelectedClass = value ? 'is-selected' : '';
  }

  @Input() set isDisabled(value: boolean) {
    this.isDisabledClass = value ? 'is-disabled' : '';
    this._isDisabled = value;
  }
  private _isDisabled = false;

  @Input() set isSmall(value: boolean) {
    this.isSmallClass = value ? 'is-small' : '';
  }
  @Output() buttonClick: EventEmitter<void> = new EventEmitter();

  isSelectedClass: 'is-selected' | '' = '';
  isDisabledClass: 'is-disabled' | '' = '';
  isSmallClass: 'is-small' | '' = '';
  constructor() {}

  ngOnInit(): void {}

  onClick(): void {
    if (this._isDisabled) {
      return;
    }
    this.buttonClick.emit();
  }
}
